import { AbstractControl } from '@angular/forms';

export const ValidateId = (control: AbstractControl) => {
    return control.value === 0 ? { error: 'El campo es requerido' } : null;
  }
